import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../lib/utility/api';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Загрузка профиля на старте. Временные ошибки (сеть/таймаут/5xx) ретраим с
// бэкоффом и НЕ роняем пользователя на /login, пока в localStorage есть токен.
// Только реальная потеря авторизации (интерцептор уже сделал clearAuth и стёр
// токен) трактуется как разлогин.
export const isLoggedIn = createAsyncThunk(
  'user/isLoggedIn',
  async (_arg, { rejectWithValue }) => {
    if (!localStorage.getItem('token')) {
      return rejectWithValue({ reason: 'no-token' });
    }

    const maxAttempts = 3;
    let lastError;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      try {
        const { data } = await api.get('/user/profile');
        return data;
      } catch (error) {
        lastError = error;

        // Интерцептор стёр токен -> refresh-токен мёртв -> честный разлогин.
        if (!localStorage.getItem('token')) {
          return rejectWithValue({ reason: 'unauthorized' });
        }

        // Токен на месте -> ошибка временная, ретраим с бэкоффом.
        if (attempt < maxAttempts - 1) {
          await sleep(500 * 2 ** attempt);
        }
      }
    }

    // Ретраи исчерпаны, но токен на месте — показываем экран ошибки/ретрая,
    // а не логин.
    return rejectWithValue({
      reason: 'transient',
      message: lastError?.response?.data?.message || lastError?.message,
    });
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    error: '',
    loading: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    removeUser: (state, action) => {
      state.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
    },
  },
  extraReducers: {
    [isLoggedIn.pending]: (state, action) => {
      state.error = '';
      state.loading = true;
    },
    [isLoggedIn.fulfilled]: (state, action) => {
      state.user = action.payload;
      state.loading = false;
    },
    [isLoggedIn.rejected]: (state, action) => {
      state.loading = false;
      state.user = null;
      state.error = 'Session expired';
      // Любая неуспешная попытка восстановления сессии на старте — логаут:
      // чистим токены и отправляем пользователя на /login, чтобы он зашёл заново.
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
    },
  },
});

export const { setUser, removeUser } = authSlice.actions;

export default authSlice.reducer;
export const useProfileSelector = (state) => {
  return state.auth.user
};
